(function () {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- Header: mobile drawer + dropdown toggles ----
  const mobileMenuBtn = document.getElementById('mobileMenuBtn');
  const navLinks = document.getElementById('navLinks');
  const mobileOverlay = document.getElementById('mobileOverlay');

  function closeMobileMenu() {
    if (!navLinks) return;
    navLinks.classList.remove('open');
    if (mobileOverlay) mobileOverlay.hidden = true;
    if (mobileMenuBtn) mobileMenuBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (mobileMenuBtn && navLinks) {
    mobileMenuBtn.addEventListener('click', () => {
      const isOpen = navLinks.classList.toggle('open');
      mobileMenuBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (mobileOverlay) mobileOverlay.hidden = !isOpen;
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  if (mobileOverlay) {
    mobileOverlay.addEventListener('click', closeMobileMenu);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMobileMenu();
  });

  // Submenu expand/collapse (mobile)
  document.querySelectorAll('.nav-item .dropdown-toggle').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const item = btn.closest('.nav-item');
      if (!item) return;
      const isExpanded = item.classList.toggle('expanded');
      btn.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    });
  });

  // Reset drawer state if resized back to desktop
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (window.innerWidth > 860) closeMobileMenu();
    }, 150);
  });

  // Hero collage parallax
  const heroVisual = document.getElementById('heroVisual');
  if (heroVisual && !reduceMotion) {
    const layers = heroVisual.querySelectorAll('[data-depth]');
    heroVisual.addEventListener('mousemove', (e) => {
      const rect = heroVisual.getBoundingClientRect();
      const cx = (e.clientX - rect.left) / rect.width - 0.5;
      const cy = (e.clientY - rect.top) / rect.height - 0.5;
      layers.forEach((el) => {
        const depth = parseFloat(el.dataset.depth);
        const baseRotate = el.classList.contains('hv-court') ? -4
          : el.classList.contains('hv-controller') ? 5
          : el.classList.contains('hv-score') ? -3 : 0;
        el.style.transform = `translate(${cx * depth}px, ${cy * depth}px) rotate(${baseRotate}deg)`;
      });
    });
    heroVisual.addEventListener('mouseleave', () => {
      layers.forEach((el) => (el.style.transform = ''));
    });
  }

  // Badge grid — cycles through categories defined via the hero section's blocks
  const grid = document.getElementById('badgeGrid');
  const pctEl = document.getElementById('badgePct');
  const labelEl = document.getElementById('badgeLabel');
  const tierEl = document.getElementById('badgeTier');
  const countEl = document.getElementById('badgeCount');
  const dataEl = document.getElementById('heroCategoriesData');

  if (grid && dataEl) {
    const TOTAL = parseInt(grid.dataset.total, 10) || 20;
    const categories = Array.from(dataEl.querySelectorAll('.hero-cat')).map((el) => ({
      label: el.dataset.label || 'Badges',
      filled: parseInt(el.dataset.filled, 10) || 0,
      tier: el.dataset.tier || ''
    }));

    if (categories.length) {
      for (let i = 0; i < TOTAL; i++) {
        const cell = document.createElement('div');
        cell.className = 'badge-cell';
        grid.appendChild(cell);
      }
      const cells = grid.querySelectorAll('.badge-cell');
      let catIndex = 0;

      const resetCells = () => cells.forEach((c) => (c.className = 'badge-cell'));

      const revealTo = (filled, i) => {
        if (i >= TOTAL) {
          if (!reduceMotion && categories.length > 1) setTimeout(nextCategory, 2600);
          return;
        }
        cells[i].classList.add(i < filled ? 'fill' : 'dim');
        if (pctEl) pctEl.textContent = Math.round((Math.min(i + 1, filled) / filled) * 100) + '%';
        setTimeout(() => revealTo(filled, i + 1), 40);
      };

      const setHeadlineWord = (word) => {
        const el = document.getElementById('rotWord');
        if (!el) return;
        if (reduceMotion) {
          el.textContent = word;
          return;
        }
        el.style.opacity = 0;
        el.style.transform = 'translateY(8px)';
        setTimeout(() => {
          el.textContent = word;
          el.style.transform = 'translateY(-8px)';
          void el.offsetWidth;
          el.style.opacity = 1;
          el.style.transform = 'translateY(0)';
        }, 250);
      };

      const playCategory = (index) => {
        const cat = categories[index];
        const filled = Math.min(cat.filled, TOTAL);
        setHeadlineWord(cat.label.split(' ')[0]);
        if (labelEl) labelEl.textContent = cat.label;
        if (tierEl) tierEl.textContent = cat.tier;
        if (countEl) countEl.textContent = `${filled} / ${TOTAL} maxed`;
        if (pctEl) pctEl.textContent = '0%';
        resetCells();
        revealTo(filled, 0);
      };

      function nextCategory() {
        catIndex = (catIndex + 1) % categories.length;
        playCategory(catIndex);
      }

      window.addEventListener('load', () => setTimeout(() => playCategory(0), 300));
    }
  }

  // Sticky mobile add-to-cart bar — shows once the hero is scrolled past,
  // or immediately on pages without a hero (e.g. the product page)
  const stickyCart = document.getElementById('stickyCart');
  const heroSection = document.querySelector('.hero');
  if (stickyCart) {
    if (heroSection && 'IntersectionObserver' in window) {
      const heroObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            stickyCart.classList.toggle('visible', !entry.isIntersecting);
          });
        },
        { threshold: 0, rootMargin: '-56px 0px 0px 0px' }
      );
      heroObserver.observe(heroSection);
    } else {
      stickyCart.classList.add('visible');
    }
  }

  // Sticky Add to Cart button mirrors the main product form
  const stickyAddToCart = document.getElementById('stickyAddToCart');
  if (stickyAddToCart) {
    stickyAddToCart.addEventListener('click', () => {
      const form = document.getElementById('productForm');
      if (form) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  }

  // Achievement stat count-up on scroll into view
  const achVals = document.querySelectorAll('.ach-val');
  function animateCount(el) {
    const target = parseInt(el.dataset.target, 10) || 0;
    const suffix = el.dataset.suffix || '';
    if (reduceMotion) {
      el.textContent = target.toLocaleString() + suffix;
      return;
    }
    const duration = 1100;
    const start = performance.now();
    function tick(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = Math.round(target * eased);
      el.textContent = value.toLocaleString() + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  if (achVals.length) {
    if ('IntersectionObserver' in window) {
      const achObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              animateCount(entry.target);
              achObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.4 }
      );
      achVals.forEach((el) => achObserver.observe(el));
    } else {
      achVals.forEach(animateCount);
    }
  }

  // Cart page: add Fast Pass upsell
  const cartAddFastPass = document.getElementById('cartAddFastPass');
  if (cartAddFastPass) {
    cartAddFastPass.addEventListener('click', () => {
      const vid = cartAddFastPass.dataset.variantId;
      cartAddFastPass.textContent = 'Adding...';
      cartAddFastPass.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      })
        .then((r) => r.json())
        .then(() => window.location.reload())
        .catch(() => {
          cartAddFastPass.textContent = 'Add';
          cartAddFastPass.disabled = false;
        });
    });
  }

  // ---- Order tracker ----
  const trackerForm = document.getElementById('trackerForm');
  if (trackerForm) {
    const input = document.getElementById('trackerInput');
    const resultEl = document.getElementById('trackerResult');
    const notFoundEl = document.getElementById('trackerNotFound');
    const dataEl = document.getElementById('trackerData');
    const defaultEta = dataEl ? (dataEl.dataset.defaultEta || '') : '';
    const sheetUrl = dataEl ? (dataEl.dataset.sheetUrl || '') : '';
    const sheetFallback = dataEl ? dataEl.dataset.sheetFallback === 'true' : true;

    const STAGES = [
      { key: 'received', label: 'Received' },
      { key: 'confirmed', label: 'Confirmed' },
      { key: 'progress', label: 'In progress' },
      { key: 'complete', label: 'Completed' }
    ];
    const STATUS_LABEL = {
      received: 'Received',
      confirmed: 'Confirmed',
      progress: 'In progress',
      complete: 'Completed'
    };
    const STATUS_BLURB = {
      received: 'Your order is in. We are reviewing the details now.',
      confirmed: 'Details are verified. You are queued for a grinder.',
      progress: 'A grinder is actively working on your account right now.',
      complete: 'All done. Your account has been returned to you.'
    };

    // Orders entered manually in the theme customizer
    const blockOrders = dataEl
      ? Array.from(dataEl.querySelectorAll('.tk-order')).map((el) => ({
          number: (el.dataset.number || '').trim().toUpperCase(),
          status: el.dataset.status || 'received',
          service: el.dataset.service || '',
          eta: el.dataset.eta || '',
          etaNote: el.dataset.etaNote || '',
          updated: el.dataset.updated || '',
          note: el.dataset.note || ''
        }))
      : [];

    let orders = blockOrders;
    let sheetLoaded = false;

    function esc(s) {
      const d = document.createElement('div');
      d.textContent = s;
      return d.innerHTML;
    }

    // Minimal CSV parser that handles quoted fields and embedded commas
    function parseCSV(text) {
      const rows = [];
      let row = [];
      let field = '';
      let inQuotes = false;
      for (let i = 0; i < text.length; i++) {
        const ch = text[i];
        if (inQuotes) {
          if (ch === '"') {
            if (text[i + 1] === '"') { field += '"'; i++; }
            else inQuotes = false;
          } else field += ch;
        } else if (ch === '"') {
          inQuotes = true;
        } else if (ch === ',') {
          row.push(field); field = '';
        } else if (ch === '\n') {
          row.push(field); field = '';
          rows.push(row); row = [];
        } else if (ch !== '\r') {
          field += ch;
        }
      }
      if (field.length || row.length) { row.push(field); rows.push(row); }
      return rows.filter((r) => r.some((cell) => cell.trim() !== ''));
    }

    function normalizeStatus(raw) {
      const s = (raw || '').trim().toLowerCase();
      if (s.startsWith('complete') || s === 'done' || s === 'finished') return 'complete';
      if (s.startsWith('progress') || s.startsWith('in progress') || s === 'working') return 'progress';
      if (s.startsWith('confirm') || s === 'queued') return 'confirmed';
      return 'received';
    }

    function ordersFromSheet(csvText) {
      const rows = parseCSV(csvText);
      if (rows.length < 2) return [];
      const headers = rows[0].map((h) => h.trim().toLowerCase().replace(/\s+/g, '_'));
      const idx = (name) => headers.indexOf(name);
      const iNum = idx('order_number');
      if (iNum === -1) return [];
      const iStatus = idx('status');
      const iService = idx('service');
      const iEta = idx('eta');
      const iEtaNote = idx('eta_note');
      const iUpdated = idx('updated');
      const iNote = idx('note');
      const get = (r, i) => (i >= 0 && r[i] ? r[i].trim() : '');

      return rows.slice(1).map((r) => ({
        number: get(r, iNum).toUpperCase().replace(/^#/, ''),
        status: normalizeStatus(get(r, iStatus)),
        service: get(r, iService),
        eta: get(r, iEta),
        etaNote: get(r, iEtaNote),
        updated: get(r, iUpdated),
        note: get(r, iNote)
      })).filter((o) => o.number !== '');
    }

    function loadSheet() {
      if (!sheetUrl) return Promise.resolve();
      return fetch(sheetUrl, { cache: 'no-store' })
        .then((r) => { if (!r.ok) throw new Error('sheet fetch failed'); return r.text(); })
        .then((txt) => {
          const parsed = ordersFromSheet(txt);
          if (parsed.length) { orders = parsed; sheetLoaded = true; }
          else if (!sheetFallback) orders = [];
        })
        .catch(() => {
          if (!sheetFallback) orders = [];
        });
    }

    const sheetReady = loadSheet();

    function renderOrder(o) {
      const stageIndex = Math.max(0, STAGES.findIndex((s) => s.key === o.status));
      const pct = (stageIndex / (STAGES.length - 1)) * 100;

      const steps = STAGES.map((s, i) => {
        let cls = 'upcoming';
        let inner = String(i + 1);
        if (i < stageIndex) { cls = 'done'; inner = '&#10003;'; }
        else if (i === stageIndex) { cls = 'current'; inner = '&#10003;'; }
        return '<div class="step-node ' + cls + '">' +
          '<div class="step-dot">' + inner + '</div>' +
          '<div class="step-label">' + s.label + '</div>' +
          (i === stageIndex ? '<div class="step-youarehere">You are here</div>' : '') +
          '</div>';
      }).join('');

      const etaValue = o.eta || defaultEta;

      resultEl.innerHTML =
        '<div class="result-card">' +
          '<div class="result-top">' +
            '<div>' +
              '<div class="result-order">Order #' + esc(o.number) + '</div>' +
              (o.service ? '<div class="result-service">' + esc(o.service) + '</div>' : '') +
            '</div>' +
            '<span class="status-chip ' + o.status + '">' + (STATUS_LABEL[o.status] || 'Received') + '</span>' +
          '</div>' +
          '<div class="stage-callout ' + o.status + '">' +
            '<div class="stage-callout-label">Current stage</div>' +
            '<div class="stage-callout-value">' + (STATUS_LABEL[o.status] || 'Received') + '</div>' +
            '<div class="stage-callout-blurb">' + (STATUS_BLURB[o.status] || '') + '</div>' +
          '</div>' +
          '<div class="progress-track"><div class="progress-fill" style="width:' + pct + '%"></div></div>' +
          '<div class="result-steps">' + steps + '</div>' +
          (etaValue ?
            '<div class="eta-banner">' +
              '<div class="eta-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg></div>' +
              '<div>' +
                '<div class="eta-label">Estimated completion</div>' +
                '<div class="eta-value">' + esc(etaValue) + '</div>' +
                (o.etaNote ? '<div class="eta-note">' + esc(o.etaNote) + '</div>' : '') +
              '</div>' +
            '</div>' : '') +
          (o.updated ? '<div class="result-meta"><div class="meta-item"><span class="meta-label">Last updated</span><span class="meta-value">' + esc(o.updated) + '</span></div></div>' : '') +
          (o.note ? '<div class="result-note">' + esc(o.note) + '</div>' : '') +
        '</div>';

      resultEl.hidden = false;
      notFoundEl.hidden = true;
      resultEl.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
    }

    function doLookup() {
      const q = (input.value || '').trim().toUpperCase().replace(/^#/, '');
      if (!q) return;
      const match = orders.find((o) => o.number.replace(/^#/, '') === q);
      if (match) renderOrder(match);
      else {
        resultEl.hidden = true;
        resultEl.innerHTML = '';
        notFoundEl.hidden = false;
      }
    }

    trackerForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = trackerForm.querySelector('button[type="submit"]');
      if (sheetUrl && !sheetLoaded) {
        const original = btn ? btn.textContent : '';
        if (btn) { btn.textContent = 'Checking...'; btn.disabled = true; }
        sheetReady.then(() => {
          if (btn) { btn.textContent = original; btn.disabled = false; }
          doLookup();
        });
      } else {
        doLookup();
      }
    });
  }

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach((item) => {
    const q = item.querySelector('.faq-q');
    if (!q) return;
    q.addEventListener('click', () => {
      const wasOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach((i) => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  // ---- Cart page: quantity steppers auto-submit the form ----
  document.querySelectorAll('.cart-qty-minus, .cart-qty-plus').forEach((btn) => {
    btn.addEventListener('click', () => {
      const key = btn.dataset.key;
      const input = document.querySelector(`.cart-qty-input[data-key="${key}"]`);
      if (!input) return;
      const current = parseInt(input.value, 10) || 0;
      input.value = btn.classList.contains('cart-qty-minus') ? Math.max(0, current - 1) : current + 1;
      input.closest('form').submit();
    });
  });
  document.querySelectorAll('.cart-qty-input').forEach((input) => {
    input.addEventListener('change', () => input.closest('form').submit());
  });

  // ---- Product page: gallery thumbnails ----
  document.querySelectorAll('.product-thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const mainImg = document.getElementById('productMainImage');
      if (mainImg) mainImg.src = thumb.dataset.full;
      document.querySelectorAll('.product-thumb').forEach((t) => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // ---- Product page: quantity stepper ----
  const qtyInput = document.getElementById('qtyInput');
  const qtyMinus = document.getElementById('qtyMinus');
  const qtyPlus = document.getElementById('qtyPlus');
  if (qtyInput && qtyMinus && qtyPlus) {
    qtyMinus.addEventListener('click', () => {
      qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
    });
    qtyPlus.addEventListener('click', () => {
      qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
    });
  }

  // ---- Product page: option pills drive variant selection ----
  const productForm = document.getElementById('productForm');
  const variantsDataEl = document.getElementById('productVariantsData');
  if (productForm && variantsDataEl) {
    const variants = Array.from(variantsDataEl.querySelectorAll('.pv')).map((el) => ({
      id: el.dataset.id,
      price: parseInt(el.dataset.price, 10) || 0,
      compare_at_price: parseInt(el.dataset.compare, 10) || 0,
      available: el.dataset.available === 'true',
      option1: el.dataset.o1 || null,
      option2: el.dataset.o2 || null,
      option3: el.dataset.o3 || null,
      featured_image: el.dataset.img ? { src: el.dataset.img } : null
    }));

    const optionGroups = productForm.querySelectorAll('.product-option-pills');
    const selectedIdInput = document.getElementById('selectedVariantId');
    const priceCurrent = document.getElementById('priceCurrent');
    const priceCompare = document.getElementById('priceCompare');
    const addToCartBtn = document.getElementById('addToCartBtn');

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function currentSelection() {
      const selection = [];
      optionGroups.forEach((group) => {
        const selectedPill = group.querySelector('.option-pill.selected');
        selection.push(selectedPill ? selectedPill.dataset.value : null);
      });
      return selection;
    }

    function findVariant(selection) {
      return variants.find((v) => {
        const opts = [v.option1, v.option2, v.option3];
        return selection.every((val, i) => val === null || opts[i] === val);
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      selectedIdInput.value = variant.id;
      if (priceCurrent) priceCurrent.textContent = money(variant.price);
      const stickyPrice = document.getElementById('stickyPrice');
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.textContent = money(variant.compare_at_price);
          priceCompare.style.display = '';
        } else {
          priceCompare.style.display = 'none';
        }
      }
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (variant.featured_image) {
        const mainImg = document.getElementById('productMainImage');
        if (mainImg) mainImg.src = variant.featured_image.src;
      }
    }

    optionGroups.forEach((group) => {
      group.querySelectorAll('.option-pill').forEach((pill) => {
        pill.addEventListener('click', () => {
          group.querySelectorAll('.option-pill').forEach((p) => p.classList.remove('selected'));
          pill.classList.add('selected');
          const variant = findVariant(currentSelection());
          updateForVariant(variant);
        });
      });
    });

    // Validate required order-detail fields
    function validateOrderFields() {
      let valid = true;
      let firstBad = null;
      productForm.querySelectorAll('[data-required="true"]').forEach((field) => {
        const wrap = field.closest('.order-field');
        const err = wrap ? wrap.querySelector('.field-error') : null;
        if (!field.value || field.value.trim() === '') {
          valid = false;
          field.classList.add('invalid');
          if (err) err.hidden = false;
          if (!firstBad) firstBad = field;
        } else {
          field.classList.remove('invalid');
          if (err) err.hidden = true;
        }
      });
      if (firstBad) firstBad.focus();
      return valid;
    }

    // Clear error state as the user types
    productForm.querySelectorAll('[data-required="true"]').forEach((field) => {
      const evt = field.tagName === 'SELECT' ? 'change' : 'input';
      field.addEventListener(evt, () => {
        if (field.value && field.value.trim() !== '') {
          field.classList.remove('invalid');
          const wrap = field.closest('.order-field');
          const err = wrap ? wrap.querySelector('.field-error') : null;
          if (err) err.hidden = true;
        }
      });
    });

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!validateOrderFields()) return;

      const formData = new FormData(productForm);
      const originalText = addToCartBtn.textContent;
      addToCartBtn.textContent = 'Adding...';
      addToCartBtn.disabled = true;

      // Fast Pass add-on: queue a second add if checked
      const fpToggle = document.getElementById('fastPassToggle');
      const fpVariantId = fpToggle && fpToggle.checked ? fpToggle.dataset.variantId : null;

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then((res) => res.json())
        .then(() => {
          if (fpVariantId) {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: fpVariantId, quantity: 1 }] })
            }).then((r) => r.json());
          }
          return null;
        })
        .then(() => {
          addToCartBtn.textContent = 'Added ✓';
          setTimeout(() => {
            addToCartBtn.textContent = originalText;
            addToCartBtn.disabled = false;
          }, 1500);
          document.dispatchEvent(new CustomEvent('cart:updated'));
          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              const cartCount = document.querySelector('.cart-count');
              if (cart.item_count > 0) {
                if (cartCount) {
                  cartCount.textContent = cart.item_count;
                } else {
                  const cartBtn = document.querySelector('.cart-btn');
                  if (cartBtn) {
                    const span = document.createElement('span');
                    span.className = 'cart-count';
                    span.textContent = cart.item_count;
                    cartBtn.appendChild(span);
                  }
                }
              }
              const stickyBar = document.getElementById('stickyCart');
              if (stickyBar) stickyBar.dispatchEvent(new CustomEvent('cart:refresh'));
            });
        })
        .catch(() => {
          addToCartBtn.textContent = originalText;
          addToCartBtn.disabled = false;
        });
    });
  }

  // Roster row "Add to Cart" — AJAX add, no full page reload
  document.querySelectorAll('.roster-row form[action="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(form);
      const btn = form.querySelector('button[type="submit"]');
      const originalText = btn.textContent;
      btn.textContent = 'Adding...';
      btn.disabled = true;

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then((res) => res.json())
        .then(() => {
          btn.textContent = 'Added ✓';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
          document.dispatchEvent(new CustomEvent('cart:updated'));
          // Refresh sticky bar / cart count without a full reload
          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              const cartCount = document.querySelector('.cart-count');
              if (cart.item_count > 0) {
                if (cartCount) {
                  cartCount.textContent = cart.item_count;
                } else {
                  const cartBtn = document.querySelector('.cart-btn');
                  if (cartBtn) {
                    const span = document.createElement('span');
                    span.className = 'cart-count';
                    span.textContent = cart.item_count;
                    cartBtn.appendChild(span);
                  }
                }
              }
            });
        })
        .catch(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  });
})();
